import { useEffect, useState } from "react"

// libraries
import { Tooltip } from "@mui/material"
import ClickAwayListener from "react-click-away-listener"

// images
import notificationImage from "@/assets/img/header/icons/notification.svg"

// providers
import { useNotificationsContext } from "@/_providers/Notifications"

// components
import Notifications from "@/components/app/modules/Notifications"

export default function NotificationsInHeader() {
  const notifications = useNotificationsContext()

  const [visible, setVisible] = useState(false)
  const [ringAnimation, setRingAnimation] = useState(false)

  useEffect(() => {
    if (notifications.count > 0) {
      setRingAnimation(true)

      const ringInterval = setInterval(() => {
        setRingAnimation(true)
        setTimeout(() => setRingAnimation(false), 1500)
      }, 300000)

      const initialTimeout = setTimeout(() => setRingAnimation(false), 1500)

      return () => {
        clearInterval(ringInterval)
        clearTimeout(initialTimeout)
      }
    } else {
      setRingAnimation(false)
    }
  }, [notifications.count])

  return (
    <ClickAwayListener onClickAway={() => setVisible(false)}>
      <>
        <Tooltip
          title={
            notifications.count ? `${notifications.count} нови известия` : ""
          }
          arrow
          placement="bottom-end"
        >
          <div
            className={`icon ${ringAnimation ? "has-notifications" : ""}`}
            onClick={() => setVisible(true)}
          >
            {notifications.count > 0 && <span></span>}
            <img src={notificationImage} alt="notification" />
          </div>
        </Tooltip>

        {visible ? <Notifications /> : <></>}
      </>
    </ClickAwayListener>
  )
}
